import React from "react";
import "./YellowFilledRoundBtn.css";
import { Button } from "react-bootstrap";

function YellowFilledRoundBtn({ btnText, onClick }) {
  return (
    <section className="YellowFilledRoundBtn">
      <Button className="yellow_Btn" onClick={onClick}>{btnText}</Button>
    </section>
  );
}

export default YellowFilledRoundBtn;
